//Session values derived from the /check-permission response.
//Only the two flags the drift check compares are kept as cookies; the rest live
//in UserContext for the life of the page load.
import { COOKIE, createCookie, deleteCookie, getCookie } from "../Cookie";

const ADJUNCT_FACULTY = '4';

const read = (data, key) => {
	const value = data?.[key];
	return value === undefined || value === null ? '' : value;
};

// University email wins, except adjunct faculty who opted into their personal one.
export const resolveContactEmail = ({ personalEmail, universityEmail, emailType }, role) => {
	if (role === ADJUNCT_FACULTY && String(emailType) === '1') return personalEmail || '';
	return universityEmail || personalEmail || '';
};

export const mapUserResponse = (data) => ({
	displayName: read(data, 'display_name'),
	shortName: read(data, 'short_name'),
	contactEmail: read(data, 'contact_email'),
	profileImage: read(data, 'profile_image'),
});

// Refreshed on every page load, so a permission that was taken away must clear.
export const savePermissions = (session) => {
	const put = (name, value) => {
		if (value === '' || value === undefined || value === null) deleteCookie(name, '/');
		else createCookie(name, value, null, '/');
	};
	put(COOKIE.IsAdvisor, session?.isAdvisor);
	put(COOKIE.ReportingTo, session?.reportingTo);
};

// Normalised to the strings the call sites compare against.
export const mapPermissions = (data) => ({
	isAdvisor: String(read(data, 'is_advisor') || '0'),
	isMentor: String(read(data, 'is_mentor') || '0'),
	isPartTime: String(read(data, 'student_type')),
	hasSurveyPermission: String(read(data, 'has_survey_permission')),
	// Both were only ever set when truthy, so call sites treat '' as unset.
	reportingTo: read(data, 'reporting_to') ? String(data.reporting_to) : '',
	semesterId: read(data, 'semester_details_id') ? String(data.semester_details_id) : '',
});

export const mapSession = (data) => ({
	...mapPermissions(data),
	...mapUserResponse(data),
});

const DRIFT_FIELDS = ['isAdvisor', 'reportingTo'];

const norm = (value) => (
	value === undefined || value === null || value === '' || value === 'undefined'
		? ''
		: String(value)
);

// Compares the server's answer with the previous page load's cookies, so it must
// run before savePermissions() overwrites them. No baseline means first load, not drift.
export const sessionDrift = (data, role) => {
	if (getCookie(COOKIE.IsAdvisor) === null) return [];

	const baseline = {
		isAdvisor: norm(getCookie(COOKIE.IsAdvisor)) || '0',
		reportingTo: norm(getCookie(COOKIE.ReportingTo)),
	};
	const candidate = mapPermissions(data);
	const drift = DRIFT_FIELDS
		.filter((key) => norm(baseline[key]) !== norm(candidate[key]))
		.map((key) => [key, baseline[key], candidate[key]]);

	// Students are sent no faculty_roles, so only staff can drift on role.
	const apiRole = norm(read(data, 'faculty_roles'));
	if (role !== '0' && apiRole && apiRole !== norm(role)) drift.push(['role', role, apiRole]);

	return drift;
};
